export default __webpack_public_path__ + "static/media/product-desktop.dc9414e5.jpg";